import { ModalFooter, ModalFooterButton } from '@/components/Modal'
import { useMode, useOnCancel } from '../../ContextProvider'
import { useGoToConfirmDiscardChangesView } from '../../ModalViewStateProvider'
import { useTexts } from './useTexts'

export function Footer() {
  const texts = useTexts()
  const goToConfirmDiscardChangesView = useGoToConfirmDiscardChangesView()
  const mode = useMode()
  const onCancel = useOnCancel()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton onClick={onCancel} testid="modal-primary-button" variant="contained">
          {texts.footer.commit(mode)}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton testid="modal-secondary-button" onClick={goToConfirmDiscardChangesView}>
          {texts.footer.manageStorage}
        </ModalFooterButton>
      }
    />
  )
}
